import { Injectable } from '@angular/core';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { ResultSI } from '@views/interfaces/services/result.interface';

@Injectable({
  providedIn: 'root',
})
export class ResultService {
  constructor(private http: HttpClient) {}

  async result(idProject: string): Promise<ResultSI> {
    const result = await firstValueFrom<ResponseCommonSI<ResultSI>>(
      this.http.get(
        `${BASE_URL}${ENDPOINTS.RESULT.replace(':idProject', idProject)}`
      )
    );
    return result.payload;
  }
}
